import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad7fe964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-50 sm-mb-20" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"header-wrapper\" data-v-ad7fe964><div class=\"container\" data-v-ad7fe964><div class=\"header-icons\" data-v-ad7fe964><a href=\"https://www.facebook.com/p/IATSE-National-Benefit-Funds-100063462075974/\" target=\"_blank\" data-v-ad7fe964><i class=\"iatse-icon-facebook\" data-v-ad7fe964></i></a></div><div class=\"header-contact\" data-v-ad7fe964><svg width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-ad7fe964><path d=\"M4.69175 1.54395L5.12442 2.31924C5.51489 3.01889 5.35814 3.93672 4.74316 4.5517C4.74316 4.5517 4.74316 4.5517 4.74316 4.55171C4.74304 4.55182 3.99731 5.29777 5.3497 6.65016C6.70143 8.0019 7.44734 7.25751 7.44815 7.2567C7.44818 7.25667 7.44816 7.25669 7.44819 7.25666C8.06317 6.64171 8.98098 6.48497 9.68062 6.87543L10.4559 7.30811C11.5124 7.89772 11.6372 9.37933 10.7085 10.308C10.1505 10.866 9.46695 11.3002 8.7113 11.3288C7.4392 11.377 5.27887 11.0551 3.11182 8.88803C0.944772 6.72098 0.62283 4.56065 0.671055 3.28856C0.699702 2.5329 1.13389 1.84933 1.69189 1.29132C2.62052 0.362692 4.10214 0.487462 4.69175 1.54395Z\" fill=\"#FCFCFC\" data-v-ad7fe964></path></svg><small data-v-ad7fe964>Toll Free 800-456 Fund (3863)</small></div></div></div>", 1)
const _hoisted_3 = { class: "header-search-wrapper container" }
const _hoisted_4 = { class: "logo-wrapper" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spotlight" }, null, -1))
const _hoisted_8 = { class: "wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("form", { class: "w-25" }, null, -1))
const _hoisted_10 = { class: "header-actions-wrapper" }
const _hoisted_11 = { class: "header-actions" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-user-rounded" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text hide-mobile" }, " Register ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-login" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text hide-mobile" }, " Login ", -1))
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-underline" }, " Forgot Credentials ", -1))
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: _ctx.baseUrl,
          class: "header-action"
        }, [
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              src: `${_ctx.baseUrl}/storage/app/media/logo.png`,
              alt: "Logo",
              title: "IATSE Benefits Fund Logo",
              width: "230"
            }, null, 8, _hoisted_6)
          ]),
          _hoisted_7
        ], 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: { name: 'register' },
              class: "header-action"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1
            }),
            _hoisted_14,
            _createVNode(_component_router_link, {
              to: { name: 'login' },
              class: "header-action"
            }, {
              default: _withCtx(() => [
                _hoisted_15,
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          _createElementVNode("a", {
            href: `${_ctx.baseUrl}/forgot-credentials`,
            class: "header-action"
          }, _hoisted_19, 8, _hoisted_17)
        ])
      ])
    ])
  ]))
}